// @ts-strict-ignore
import {ExpressionNode} from './expression-node';
import {OperandNode} from './operand-node';
import {Expression, Operator, SerializedOperand} from './types';

export class OperatorNode extends ExpressionNode {
  public static deserialize(expression: Expression | SerializedOperand): ExpressionNode {
    if (expression) {
      if (OperatorNode.isExpression(expression)) {
        const [left, right] = expression.children;
        return new OperatorNode(expression.operator, OperatorNode.deserialize(left), OperatorNode.deserialize(right));
      }
      return new OperandNode(expression);
    }

    return null;
  }

  private static isExpression(expression: Expression | SerializedOperand): expression is Expression {
    return (expression as Expression).operator !== undefined;
  }

  constructor(
    public operator: Operator,
    public left: ExpressionNode,
    public right: ExpressionNode,
  ) {
    super(left, right);
  }

  public serialize(): Expression {
    return {
      children: [this.left, this.right].filter(Boolean).map((child) => child.serialize()),
      operator: this.operator,
    };
  }
}
